module.exports = __webpack_public_path__ + "img/illustration-element-03.bb2f9aeb.svg";